<template>
  <b-card no-body >
    <b-card-body>
      <b-card-title>{{$t('Permissions')}}</b-card-title>
      <b-card-sub-title>{{$t('Permission according to roles')}}</b-card-sub-title>
    </b-card-body>
    <b-table striped responsive :items="permissions" :fields="fields" class="mb-0" >

      <template #cell(module)="data"> {{ $t(data.value) }} </template>
      <template #cell(read)="data">   <b-form-checkbox   :class="(data.item.read_from == 'Rol') ? 'rol-checkbox' : '' " disabled  :checked="data.value" /> </template>
      <template #cell(write)="data">  <b-form-checkbox  :class="(data.item.write_from == 'Rol') ? 'rol-checkbox' : '' " disabled  :checked="data.value" /> </template>
      <template #cell(create)="data"> <b-form-checkbox :class="(data.item.create_from == 'Rol') ? 'rol-checkbox' : '' " disabled  :checked="data.value" /> </template>
      <template #cell(delete)="data"> <b-form-checkbox :class="(data.item.delete_from == 'Rol') ? 'rol-checkbox' : '' " disabled  :checked="data.value" /> </template>

    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, } from 'bootstrap-vue'
import i18n from '@/libs/i18n'

export default {

  // COMPONENTES
  components: { BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, },

    data() {
      return {
        fields: [
          { key: 'module', label: i18n.t('Module') },
          { key: 'read', label: i18n.t('Read') },
          { key: 'write', label: i18n.t('Write') },
          { key: 'create', label: i18n.t('Create') },
          { key: 'delete', label: i18n.t('Delete') },
        ],
      }
    },

  // PROPIEDADES
  props: {
    permissions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style>
  .rol-checkbox label::before{
    background-color: lightcoral !important;
  }
</style>
